export const routes = [
  ...require('./truckWeightCapacity/routes').routes,
  ...require('./vehicleComponentGroup/routes').routes,
  ...require('./vehicle/routes').routes
]
